export const isNull = (value) => {
  return value === null || value === 'null' || value === '' ? true : false
}

export const isUndefined = (value) => {
  return value === undefined || value === 'undefined' ? true : false
}

export const isNan = (value) => Number.isNaN(value)

export const isNu = (value) => {
  return this.isNull(value) || this.isUndefined(value) ? true : false
}

export const isNun = (value) => {
  return this.isNull(value) || this.isUndefined(value) || this.isNan(value) ? true : false
}

export const isStr = (value) => {
  return typeof value === 'string' ? true : false
}

export const isInt = (value) => {
  return Number.isInteger(value) ? true : false
}

export const isEmpty = (value) => {
  return value === '' ? true : false
}

export const isEmptyArray = (value) => {
  return Array.isArray(value) && value.length === 0 ? true : false
}

export const isSet = (value) => {
  return this.isEmpty(value) || this.isNun(value) ? false : true
}

export const isObject = (value) => {
  return typeof value === 'object' ? true : false
}

export const isFunction = (value) => {
  return typeof value === 'function' ? true : false
}

export const isArray = (value) => {
  return Array.isArray(value) ? true : false
}

export const isElement = (elem) => {
  return elem instanceof Element ? true : false
}

/**
 *
 *
 *
 * ===== จัดการ element =====
 *
 *
 *
 */

export const e = (selector) => {
  return document.querySelector(selector)
}

export const getCssValue = (elem, property) => {
  if (this.isElement(elem)) {
    return window.getComputedStyle(elem, null).getPropertyValue(property)
  } else {
    elem = this.e(elem)
    return elem ? window.getComputedStyle(elem, null).getPropertyValue(property) : null
  }
}

export const css = (selector, value) => {
  if (typeof selector === 'object') {
    selector.setAttribute('style', value)
  } else {
    document.querySelector(selector).setAttribute('style', value)
  }
}

export const addClass = (selector, className) => {
  if (typeof selector === 'object') {
    if (this.isArray(className)) {
      document.querySelector(selector).classList.add(...className)
    } else {
      document.querySelector(selector).classList.add(className)
    }
  } else {
    if (this.isArray(className)) {
      selector.classList.add(...className)
    } else {
      selector.classList.add(className)
    }
  }
}

export const removeClass = (selector, className) => {
  if (typeof selector === 'object') {
    if (this.isArray(className)) {
      document.querySelector(selector).classList.remove(...className)
    } else {
      document.querySelector(selector).classList.remove(className)
    }
  } else {
    if (this.isArray(className)) {
      selector.classList.remove(...className)
    } else {
      selector.classList.remove(className)
    }
  }
}

export const toggleClass = (selector, className) => {
  if (typeof selector === 'object') {
    if (this.isArray(className)) {
      document.querySelector(selector).classList.toggle(...className)
    } else {
      document.querySelector(selector).classList.toggle(className)
    }
  } else {
    if (this.isArray(className)) {
      selector.classList.toggle(...className)
    } else {
      selector.classList.toggle(className)
    }
  }
}

/**
 *
 *
 *
 * ===== แปลงค่า =====
 *
 *
 *
 */
export const toStr = (value) => {
  return value.toString()
}

export const toInt = (value) => {
  return parseInt(value)
}

export const toFloat = (value) => {
  return parseFloat(value)
}

export const toJsonObject = (jsonString) => {
  return JSON.parse(jsonString)
}

export const toJsonString = (jsonObject) => {
  return JSON.stringify(jsonObject)
}

export const allObjectToNull = (object) => {
  for (const [key] of Object.entries(object)) {
    if (this.isObject(object[key]) && !this.isNull(object[key])) {
      // _.log(object[key])
      this.allObjectToNull(object[key])
    } else {
      // _.log([key, item])
      object[key] = null
    }
  }

  return object
}

export const formatFileSize = (
  size,
  units = ['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  delimiter = ' '
) => {
  const threshold = 1024
  size = size * threshold
  const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(threshold))
  return (size / Math.pow(threshold, i)).toFixed(2) * 1 + delimiter + units[i]
}

/**
 *
 *
 *
 * ===== จัดการไฟล์ =====
 *
 *
 *
 */
export const getFile = (event) => {
  return event.target.files[0] ? event.target.files[0] : null
}

export const getFiles = (event) => {
  return event?.target?.files ?? null
}

export const getFileName = (event) => {
  return event.target.files[0].name ? event.target.files[0].name : null
}

export const getBase64Image = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}

/**
 *
 *
 *
 * ===== เปลี่ยนสี % =====
 *
 *
 *
 */
export const toLighter = (color, percent) => {
  return this.changeShade(percent / 100, color)
}

export const toDarker = (color, percent) => {
  return this.changeShade(-(percent / 100), color)
}


export const generateID = () => {
  return Math.random().toString(36).slice(2, 15)
}

export const generateUniqueId = () => {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
    (+ (c ^ (window.crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> + (c / 4))))).toString(16)
  );
}

export const extracThaiMonthYear = (dateString) => {
  const thaiMonths = [
    "ม.ค.",
    "ก.พ.",
    "มี.ค.",
    "เม.ย.",
    "พ.ค.",
    "มิ.ย.",
    "ก.ค.",
    "ส.ค.",
    "ก.ย.",
    "ต.ค.",
    "พ.ย.",
    "ธ.ค.",
  ];
  const date = new Date(dateString);
  const month = thaiMonths[date.getMonth()];
  const year = (date.getFullYear() + 543) % 100;
  return `${month} ${year}`;
};


export const convertToThaiDate = (dateString) => {
  const thaiMonths = [
    "ม.ค.",
    "ก.พ.",
    "มี.ค.",
    "เม.ย.",
    "พ.ค.",
    "มิ.ย.",
    "ก.ค.",
    "ส.ค.",
    "ก.ย.",
    "ต.ค.",
    "พ.ย.",
    "ธ.ค.",
  ];

  const date = new Date(dateString);
  const day = date.getDate();
  const month = thaiMonths[date.getMonth()];
  const year = (date.getFullYear() + 543) % 100;

  return `${day} ${month} ${year}`;
};


export const isSvgTag = (str) => {
  const SvgString = new DOMParser()
      .parseFromString(str, "image/svg+xml")
      .querySelector("svg");
      if (SvgString) {
          const formatSVGLine = SvgString.outerHTML
              .replaceAll(/\n/g, "")
              .replaceAll(/\r/g, "")
              .replaceAll(/\t/g, "")
              .trim();
          const svgRegex = /^\s*<svg[^>]*>\s*(.*)\s*<\/svg>\s*$/;
          return svgRegex.test(formatSVGLine);
      }
  return false;
};
export const iconSvgWidthHeight = (SvgData) => {
  const widthRegex = /width="[^"]*"/g;
  const heightRegex = /height="[^"]*"/g;
  const fillRegex = /fill="[^"]*"/g;

  const SvgString = new DOMParser()
      .parseFromString(SvgData, "image/svg+xml")
      .querySelector("svg");
  if (!SvgString.getAttribute("width")) {
      SvgString.setAttribute("width", "1em");
  }
  if (!SvgString.getAttribute("height")) {
      SvgString.setAttribute("height", "1em");
  }
  const formatSVGLine = SvgString.outerHTML
      .replaceAll(/\n/g, "")
      .replaceAll(/\r/g, "")
      .replaceAll(/\t/g, "")
      .trim();
  const filled = SvgData.filled ? SvgData.filled : false;
  const updatedWidthHeightSvg = formatSVGLine
      .replace(widthRegex, `width="1em"`)
      .replace(heightRegex, `height="1em"`);

  const updatedFillSvg = updatedWidthHeightSvg.replace(
      fillRegex,
      `fill="currentColor"`
  );

  return filled ? updatedWidthHeightSvg : updatedFillSvg;
};
// Birthday from the login backends (YYYY-MM-DD, ISO datetime or DD/MM/YYYY,
// ค.ศ. or พ.ศ.) → { yearOB, monthOB, dayOB } in ค.ศ. for the /register form.
// Returns {} when it can't be read, so the form just leaves it empty.
export const splitBirthday = (value) => {
  const s = `${value || ''}`.trim()
  let m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/)
  let y, mo, d
  if (m) [, y, mo, d] = m
  else if ((m = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/))) [, d, mo, y] = m
  else return {}
  y = Number(y)
  if (y > 2400) y -= 543
  return {
    yearOB: `${y}`,
    monthOB: `${mo}`.padStart(2, '0'),
    dayOB: `${d}`.padStart(2, '0'),
  }
}
